<template><div></div></template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { retry, stopAfterAttempt, waitFixed } from "@/services/RetryService.js";

const maxWaitTime = process.env.VUE_APP_MAX_WAIT_TIME
  ? parseInt(process.env.VUE_APP_MAX_WAIT_TIME)
  : 8000;

const maxRetriesCount = process.env.VUE_APP_MAX_LOGIN_RETRIES_COUNT
  ? parseInt(process.env.VUE_APP_MAX_LOGIN_RETRIES_COUNT)
  : 10;

export default {
  name: "Callback",

  data: () => ({
    retryToken: null,
    errorCode: "",
  }),

  computed: {
    ...mapGetters(["nextPage", "getRandomRetryMessages"]),
  },

  methods: {
    ...mapMutations(["setLoadingMessages"]),
    ...mapActions(["login", "retryLogin", "token"]),

    pushHomeOrNextPage() {
      this.setLoadingMessages([" "]);
      if (this.nextPage) {
        this.$router.push(this.nextPage);
        localStorage.removeItem("nextPage");
      } else {
        this.$router.push({ name: "Home" });
      }
    },

    loginFail() {
      this.errorCode = "";
      this.setLoadingMessages([" "]);
      this.$router.push({ name: "Login" });
    },

    tryToLogin(auth) {
      this.login(auth)
        .then(() => {
          this.pushHomeOrNextPage();
        })
        .catch(async (e) => {
          if (e.code === "INVALID_GOOGLE_ACCESS_TOKEN") {
            this.setLoadingMessages(this.getRandomRetryMessages());
            this.retryToken = e.token;
            await this.tryToLoginAgain();
          } else {
            this.loginFail();
          }
        });
    },

    async tryToLoginAgain() {
      const auth = {
        headers: {
          Authorization: this.retryToken,
        },
      };
      await retry(
        async () => {
          return await this.retryLogin(auth)
            .then(() => {
              this.pushHomeOrNextPage();
              return Promise.resolve();
            })
            .catch((e) => {
              this.errorCode = e.code;
              if (e.code === "INVALID_GOOGLE_ACCESS_TOKEN") {
                this.setLoadingMessages(this.getRandomRetryMessages());
                this.retryToken = e.token;
              }
              return Promise.reject(e);
            });
        },
        {
          stop: stopAfterAttempt(maxRetriesCount),
          wait: waitFixed(maxWaitTime),
          retry: () => {
            return (
              !this.token && this.errorCode === "INVALID_GOOGLE_ACCESS_TOKEN"
            );
          },
          failedCallback: this.loginFail,
        }
      );
    },
  },

  mounted() {
    const query = Object.assign({}, this.$route.query);
    this.$router.replace({ query: null });

    this.tryToLogin({ params: query });
  },
};
</script>
